import Header from "../../components/private/header";
import Navigation from "../../components/private/navigation";
import Main from "../../components/private/main";
import Footer from "../../components/private/footer";
import { getAuth } from "../../components/utils/auth";
import Message from "../../components/private/message";

export default () => {
  const user = getAuth();

  return (
    <>
      <Header user={user} />
      <Navigation />
      <Main content={<Message user={user} />} />
      <Footer />
    </>
  );
};
